import BarChart from './bar_chart.js'
import DoughnutChart from './doughnut_chart.js'
import LineChart from './line_chart.js'
import CdfChart from './cdf_chart.js'

export default {
  BarChart,
  DoughnutChart,
  LineChart,
  CdfChart
}
